import React from 'react';
import PropTypes from 'prop-types';
import SourceCheckerResult from '../../../SourceCheckerResult';

const SourceCheckerDomainList = (props) => {
  const {
    styles,
    selectedSourceType,
    results,
    filters,
    filterHandler,
    hasGroups,
  } = props;

  let resultComponents = null;

  resultComponents = results.reduce((components, sourceCheckerResult, i) => {
    const {
      domain,
      authorGroupNames,
      isCovered,
      isValid,
      lastCoveredAt,
      mediaOutlet,
      sourceProviders,
      storyCount,
    } = sourceCheckerResult;

    const showResult = filterHandler(filters, sourceCheckerResult);

    if(showResult) {
      components.push(
        <div className={styles.sourceWrapper} key={`result_${i}`}>
          <SourceCheckerResult
            searchType={selectedSourceType}
            domain={domain}
            authorGroupNames={authorGroupNames}
            isCovered={isCovered}
            isValid={isValid}
            lastCoveredAt={lastCoveredAt}
            mediaOutlet={mediaOutlet}
            showMatchingAuthorGroups
            sourceProviders={sourceProviders}
            storyCount={storyCount}
            hasGroups={hasGroups}
          />
        </div>
      );
    }

    return components;
  }, []);

  return (
    <div className={styles.listWrapper}>
      {resultComponents}
    </div>
  );
};

SourceCheckerDomainList.propTypes = {
  styles: PropTypes.object,
  selectedSourceType: PropTypes.oneOf(['domain']),
  results: PropTypes.array,
  similars: PropTypes.object,
  filters: PropTypes.object,
  filterHandler: PropTypes.func,
  hasGroups: PropTypes.bool,
};

export default SourceCheckerDomainList;
